import { z } from 'zod';
export const MerchantDetailsSchema = z.object({
    companyName: z.string().nullable(),
    alternativeCompanyNames: z.array(z.string()).nullish(),
    registrationNumber: z.string().nullable(),
    phoneNumbers: z.array(z.string()).nullable(),
    emailAddresses: z.array(z.string()).nullable(),
    country: z.string().nullable(),
    physicalAddresses: z.array(z.string()).nullable(),
    status: z.string().nullable().optional(),
    website: z.string().nullable().optional(),
    associatedPersons: z.array(z.string()).nullable().optional(),
    detailsComparison: z.string().nullable()
}).meta({
    id: 'MerchantDetails'
});

//# sourceMappingURL=merchant-details.schema.js.map